import {AnyAction, createSlice} from '@reduxjs/toolkit';
import {IProductStateOrigin, TProductState} from 'modules/products/types';
import {HYDRATE} from 'next-redux-wrapper';
import {IRootReducer} from 'core/redux/reducers';
import {createPaginationActions} from 'plugins/modules/pagination/actions';
import {withPagination} from 'plugins/modules/pagination/state';
import {withFilter} from 'plugins/modules/filter/state';
import {createFilterActions} from 'plugins/modules/filter/actions';
import {withSorting} from 'plugins/modules/sorting/state';
import {createSortingActions} from 'plugins/modules/sorting/actions';
import {withListing} from 'plugins/modules/listing/state';
import {createListingActions} from 'plugins/modules/listing/actions';
import {addFilterExtraReducers} from 'plugins/modules/filter/reducer';

export const productsModuleName = 'products';

const initialState: TProductState = withListing(
    withSorting(
        withFilter(
            withPagination<IProductStateOrigin>({
                sectionId: null,
                storeFilterList: [],
                viewedProductsList: [],
            }),
        ),
    ),
);

export const productsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action: AnyAction) => {
            const payload = action.payload as IRootReducer | undefined;
            if (!payload) {
                return state;
            }

            return {
                ...payload[productsModuleName],
                isFilterPanelVisible: state.isFilterPanelVisible,
            };
        });
        addFilterExtraReducers<TProductState>(builder);
    },
    initialState,
    name: productsModuleName,
    reducers: {
        ...createPaginationActions<TProductState>(),
        ...createFilterActions<TProductState>(),
        ...createSortingActions<TProductState>(),
        ...createListingActions<TProductState>(),
    },
});

export const {reducer: productsReducer} = productsSlice;
